import { FolderIdentification } from './folder-identification';

export class FolderMoveToBoxNotification {
    public viewId: number;
    public targetBoxId: string;
    public movedFolderIdentifications: FolderIdentification[];

    public static fromJson(other: any): FolderMoveToBoxNotification {
        const instance = new FolderMoveToBoxNotification();
        instance.viewId = other.ViewId;
        instance.targetBoxId = other.TargetBoxId;
        instance.movedFolderIdentifications = other.MovedFolderIdentifications;
        return instance;
    }
}
